const ServiceTypesModel = Backbone.Model.extend({
  defaults: {

  },

  initialize() {
  },
});

export default ServiceTypesModel;
